import { defineStore } from 'pinia';
import { EPopupName } from '~/types/popups';
import { EOverlayItemType, type IOverlayItem, useOverlayQueueStore } from './overlayQueue';

export const useStorePopups = defineStore('abstractPopups', {
  getters: {
    /**
     * detection of opened popups
     *
     * @returns true if opened
     * @returns false if no popups opened
     */
    isPopupActive(): boolean {
      return useOverlayQueueStore().queue.some(
        (queueItem) => queueItem.type === EOverlayItemType.popup
      );
    },

    /**
     * list of opened popups
     *
     * @returns array of enums EPopupName with opened popups
     * @returns null if no popups opened
     */
    activePopups(): IOverlayItem[] | undefined {
      return useOverlayQueueStore().queue.filter(
        (queueItem) => queueItem.type === EOverlayItemType.popup
      );
    },

    /**
     * detection of opened burger menu status
     *
     * @returns true if opened
     * @returns false if burger menu is closed
     */
    isBurgerMenuOpened(): boolean {
      return !!(
        this.activePopups && this.activePopups.find((p) => p.name === EPopupName.mobileBurgerMenu)
      );
    },

    isLoaderOpened(): boolean {
      return !!(this.activePopups && this.activePopups.find((p) => p.name === EPopupName.loader));
    },
  },

  actions: {
    /**
     * Open popup (or add +1 to queue if already opened)
     *
     * @param popupName - enum of popup window
     */
    openPopup(popupName: EPopupName) {
      switch (popupName) {
        case EPopupName.sendMessagePopup:
          useOverlayQueueStore().addToOverlayQueue(
            {
              name: popupName,
              type: EOverlayItemType.popup,
              shouldBeAttchedToQuery: true,
            },
            { force: true }
          );
          break;
        default:
          useOverlayQueueStore().addToOverlayQueue({
            name: popupName,
            type: EOverlayItemType.popup,
          });
          break;
      }
    },
    /**
     * close popup
     *
     * @param popupName - enum of popup window
     */
    closePopup(popupName: EPopupName) {
      useOverlayQueueStore().removeFromOverlayQueue(popupName);
    },

    /**
     * close all popup
     *
     */
    closeAllPopups() {
      useOverlayQueueStore().removeFromOverlayQueueByType(EOverlayItemType.popup);
    },
  },
});
